import { render } from "./manage-coupon.vue?vue&type=template&id=0ba4df59"
import script from "./manage-coupon.vue?vue&type=script&lang=js"
export * from "./manage-coupon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__